import React from 'react';
import { resolveUrl } from '../../api';
import { useTheme } from '../../theme';

/** EK2 · Bilder på boendet: en vågrät rad som går att svepa. */
export function LodgingImages({ images, name }: { images: string[]; name: string }) {
  const T = useTheme();
  if (!images.length) return null;
  return (
    <div style={{ display: 'flex', gap: 8, overflowX: 'auto', scrollSnapType: 'x mandatory', paddingBottom: 2 }} data-testid="lodging-gallery">
      {images.map((u, i) => (
        <a key={u} href={resolveUrl(u)} target="_blank" rel="noreferrer" style={{ flex: '0 0 auto', scrollSnapAlign: 'start' }}>
          <img src={resolveUrl(u)} alt={`${name}, bild ${i + 1}`} loading="lazy"
            style={{ height: 140, width: 'auto', maxWidth: '80vw', borderRadius: 10, objectFit: 'cover', display: 'block', border: `1px solid ${T.border}` }} />
        </a>
      ))}
    </div>
  );
}

interface Info { checkInTime?: string | null; checkOutTime?: string | null; checkInInfo?: string | null; checkOutInfo?: string | null; cleaningInfo?: string | null }
export const hasLodgingInfo = (i: Info) => !!(i.checkInInfo || i.checkOutInfo || i.cleaningInfo);

/** EK2 · In- och utcheckning och städning (för den som bokat och markens medlemmar). Fälls ut på begäran. */
export function LodgingInstructions({ info, open }: { info: Info; open?: boolean }) {
  const T = useTheme();
  if (!hasLodgingInfo(info)) return null;
  const parts: [string, string | null | undefined][] = [
    [`Incheckning${info.checkInTime ? ` från ${info.checkInTime}` : ''}`, info.checkInInfo],
    [`Utcheckning${info.checkOutTime ? ` senast ${info.checkOutTime}` : ''}`, info.checkOutInfo],
    ['Städning', info.cleaningInfo],
  ];
  return (
    <details open={open} style={{ fontSize: 14, color: T.text }} data-testid="lodging-instructions">
      <summary style={{ cursor: 'pointer', fontWeight: 700, minHeight: 32, display: 'flex', alignItems: 'center' }}>Instruktioner för vistelsen</summary>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 6 }}>
        {parts.filter(([, v]) => v).map(([k, v]) => (
          <div key={k}>
            <div style={{ fontSize: 13, fontWeight: 700, color: T.textSub }}>{k}</div>
            <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{v}</div>
          </div>
        ))}
      </div>
    </details>
  );
}
